import { EventActions } from '../actions'
import { handleError } from '../handle-error'
import { PaymentSectionProps } from '../modules/checkout/payment-section'
import { Storage } from '../storage'
import {
    EventState,
    EventView,
    GiftCardState,
    GiftCardView,
    PaymentOption,
    SerialTicketState,
    SerialTicketView,
} from '../types'

export const getPaymentSection = (view: EventView): PaymentSectionProps => {
    const { state }: EventView = view
    const { lang, validationErrors }: EventState = state

    return {
        title: lang.banks_title,
        paymentOptions: state.paymentOptions,
        errors: validationErrors?.gateway ?? undefined,
        selectedPaymentGateway: {
            value: getSelectedPaymentGateway(state.paymentOptions),
            onChange: async (name: string) => {
                Storage.update({ selectedPaymentGateway: name })
                view.update()
                try {
                    await EventActions.validateSelectedPaymentGateway(view)
                } catch (error) {
                    handleError(view, error as Error)
                }
            },
        },
    }
}

export const getGiftCardPaymentSection = (view: GiftCardView): PaymentSectionProps => {
    const { state }: GiftCardView = view
    const { lang, validationErrors }: GiftCardState = state

    return {
        title: lang.banks_title,
        paymentOptions: state?.data?.paymentOptions ?? [],
        errors: validationErrors?.gateway ?? undefined,
        selectedPaymentGateway: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            value: getSelectedPaymentGateway(state.data.paymentOptions),
            onChange: async (name: string) => {
                Storage.update({ selectedPaymentGateway: name })
                view.update()
                // try {
                //     await EventActions.validateSelectedPaymentGateway(view)
                // } catch (error) {
                //     handleError(view, error as Error)
                // }
            },
        },
    }
}

export const getSerialTicketPaymentSection = (view: SerialTicketView): PaymentSectionProps => {
    const { state }: SerialTicketView = view
    const { lang, validationErrors }: SerialTicketState = state

    return {
        title: lang.banks_title,
        paymentOptions: state?.data?.paymentOptions ?? [],
        errors: validationErrors?.gateway ?? undefined,
        selectedPaymentGateway: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            value: getSelectedPaymentGateway(state.data.paymentOptions),
            onChange: async (name: string) => {
                Storage.update({ selectedPaymentGateway: name })
                view.update()
                // try {
                //     await EventActions.validateSelectedPaymentGateway(view)
                // } catch (error) {
                //     handleError(view, error as Error)
                // }
            },
        },
    }
}

const getSelectedPaymentGateway = (paymentOptions: PaymentOption[]): string => {
    let storageValue: string = Storage.get('selectedPaymentGateway')

    if (!storageValue && paymentOptions.length === 1) {
        const defaultOption: string = paymentOptions[0].name
        Storage.update({ selectedPaymentGateway: defaultOption })
        storageValue = defaultOption
    }

    return storageValue
}
